import { Injectable } from '@angular/core';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { ReferenceQuestionStoreModel } from '@examdojo/reference-question';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReferenceQuestionListService extends AbstractSimpleListViewService<ReferenceQuestionStoreModel> {
  constructor() {
    super();
  }

  readonly data$ = of([]);
  readonly loading$ = of(false);
  override hasItems$ = of(true);
}
